module.exports = __webpack_public_path__ + "media/images/flags/na-4322251d80b513d70f0aa9cac4864272.svg";